/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs */

const en_help_center__refund_policy__bid_package__no_refunds = /** @type {((inputs: Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`No Refunds on Bid Packages: Bid packages are non-refundable once purchased. Bids expire at the end of a battle unless you have a Premium Account.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "No Refunds on Bid Packages:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " Bid packages are " }, { type: "markup-start", name: "strong", options: {}, attributes: { "primary": true } }, { type: "text", value: "non-refundable" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " once purchased. Bids expire at the end of a battle unless you have a Premium Account." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "No Refunds on Bid Packages: Bid packages are non-refundable once purchased. Bids expire at the end of a battle unless you have a Premium Account." |
*
* @param {Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__bid_package__no_refunds = /** @type {((inputs?: Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs, { locale?: "en" }, { strong: { options: {}; attributes: { primary?: true }; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__bid_package__no_refunds(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Bid_Package__No_RefundsInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__bid_package__no_refunds.parts === "function" ? en_help_center__refund_policy__bid_package__no_refunds.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__bid_package__no_refunds(inputs) }]
			})
		}
	)
);